'use client';

import { c as _c } from "react/compiler-runtime";
import { ThemeProvider } from 'next-themes';
import type React from 'react';
import { Suspense } from 'react';
import { AnalyticsProvider } from '@/components/providers/AnalyticsProvider';
import { ClickIdTracker } from '@/components/providers/ClickIdTracker';
import StrapiPreviewListener from '@/components/providers/StrapiPreviewListener';
import { env } from '@/env.mjs';
import { BugsnagBrowserClient, BugsnagPerformanceClient } from './BugsnagBrowserClient';
const enabledReleaseStages = ['production', 'staging', 'development'];
const releaseStage = env.NEXT_PUBLIC_APP_ENV;
const apiKey = env.NEXT_PUBLIC_BUGSNAG_API_KEY;
const isEnabled = env.NEXT_PUBLIC_BUGSNAG_ENABLED;
const isMonitoringEnabled = enabledReleaseStages.includes(releaseStage) && isEnabled && apiKey;
export function ClientProviders(t0) {
  const $ = _c(9);
  const {
    children,
    listenToStrapiUpdates
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = isMonitoringEnabled ? <><BugsnagBrowserClient appType={env.NEXT_PUBLIC_BUGSNAG_APP_TYPE} apiKey={apiKey} appVersion={env.NEXT_PUBLIC_BUGSNAG_APP_VERSION} releaseStage={env.NEXT_PUBLIC_APP_ENV} enabledReleaseStages={enabledReleaseStages} /><BugsnagPerformanceClient apiKey={apiKey} appVersion={env.NEXT_PUBLIC_BUGSNAG_APP_VERSION} releaseStage={env.NEXT_PUBLIC_APP_ENV} enabledReleaseStages={enabledReleaseStages} /></> : null;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== listenToStrapiUpdates) {
    t2 = listenToStrapiUpdates && <StrapiPreviewListener />;
    $[1] = listenToStrapiUpdates;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children) {
    t3 = <AnalyticsProvider amplitudeApiKey={env.NEXT_PUBLIC_AMPLITUDE_API_KEY}>{children}</AnalyticsProvider>;
    $[3] = children;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Suspense fallback={null}><ClickIdTracker /></Suspense>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3) {
    t5 = <ThemeProvider attribute="class" defaultTheme="system" enableSystem={true} forcedTheme="light">{t1}{t2}{t3}{t4}</ThemeProvider>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}